export interface FeedItem {
  id: number;
  category: string;
  tag: string;
  title: string;
  summary: string;
  author: string;
  date: string;
  readCount: string;
  hot: number;
  image: string;
}

export interface Category {
  name: string;
  desc: string;
  count: string;
  image: string;
  accent: boolean;
}

export interface Special {
  key: string;
  category: string;
  title: string;
  summary: string;
  points: string[];
  date: string;
  reads: string;
  image: string;
  featured: boolean;
}

export interface Voice {
  name: string;
  role: string;
  text: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const categoryList = [
  "全部",
  "人设反差",
  "校园反差",
  "职场反差",
  "情感反差",
  "网络反差",
  "圈子反差",
] as const;

export const feedItems: FeedItem[] = [
  {
    id: 1,
    category: "人设反差",
    tag: "今日热议",
    title: "网友晒出双面朋友圈：白天岁月静好，深夜竟在狂飙",
    summary: "一位博主的两个账号被同好扒出，白天是文艺慢生活的分享者，深夜聊天却话题尺度拉满。反差之大，让评论区当场炸锅。",
    author: "观察员·阿岚",
    date: "今日 10:24",
    readCount: "12.6万",
    hot: 98,
    image: "https://readdy.ai/api/search-image?query=%E4%B8%80%E9%98%B3%E5%8F%B0%E7%9A%84%E6%89%8B%E6%9C%BA%E5%B1%8F%E5%B9%95%E5%92%8C%E5%86%99%E5%AE%9E%E6%89%93%E5%8D%B0%E9%A1%B5%EF%BC%8C%E5%AE%A4%E5%86%85%E6%9A%96%E9%BB%84%E7%81%AF%E5%85%89%E4%B8%8B%E4%B8%A4%E9%9D%A2%E5%AF%B9%E6%AF%94%E7%9A%84%E6%83%85%E6%99%AF%EF%BC%8C%E8%BE%B9%E7%BC%98%E5%8C%96%E6%A8%A1%E7%B3%8A%EF%BC%8C%E7%BC%96%E8%BE%91%E9%A3%8E%E5%86%99%E5%AE%9E%EF%BC%8C%E6%9A%96%E5%92%8C%E8%83%B6%E7%89%87%E8%B4%A8%E6%84%9F&width=800&height=560&seq=feed-01-x1&orientation=landscape",
  },
  {
    id: 2,
    category: "校园反差",
    tag: "热榜第3",
    title: "学霸人设翻车实录：课堂笔记工整，聊天却在自嘲摆烂",
    summary: "看似自律满分的人人眼里的学霸，私聊里却一晚上连开多个小号发泄情绪。同一副面孔，两种活法。",
    author: "观察员·栗子",
    date: "今日 09:12",
    readCount: "9.8万",
    hot: 91,
    image: "https://readdy.ai/api/search-image?query=%E5%AD%A6%E7%94%9F%E8%AF%BE%E6%A1%8C%E4%B8%8A%E6%95%B4%E9%BD%90%E7%9A%84%E7%AC%94%E8%AE%B0%E6%9C%AC%E4%B8%8E%E7%AC%94%E5%85%B7%EF%BC%8C%E5%B9%B2%E5%87%80%E6%98%8E%E4%BA%AE%E7%9A%84%E6%95%99%E5%AE%A4%E5%85%89%E7%BA%BF%EF%BC%8C%E9%AB%98%E9%80%9F%E5%86%99%E5%AE%9E%E7%85%A7%E7%89%87%E6%84%9F%EF%BC%8C%E6%B0%91%E6%94%BF%E8%92%B8%E6%B0%94%E6%84%9F%EF%BC%8C%E6%B8%A9%E6%9A%96%E5%B0%8F%E6%B8%85%E6%96%B0%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=feed-02-x1&orientation=landscape",
  },
  {
    id: 3,
    category: "职场反差",
    tag: "精选",
    title: "上班邮件礼貌客套，离职群里爆料的账号竟是同一个他",
    summary: "一封封用词克制的商务邮件背后，是同一位同事在下班后的群里口无遮拦。职场面具有多厚，扒开就有多意外。",
    author: "观察员·南乔",
    date: "昨日 22:40",
    readCount: "15.2万",
    hot: 96,
    image: "https://readdy.ai/api/search-image?query=%E5%8A%9E%E5%85%AC%E6%A1%8C%E5%89%8D%E7%94%B5%E8%84%91%E4%B8%8E%E6%95%B4%E9%BD%90%E6%96%87%E4%BB%B6%EF%BC%8C%E7%81%B0%E8%89%B2%E8%B0%83%E7%9A%84%E5%86%B0%E5%86%B7%E5%8A%9E%E5%85%AC%E7%A9%BA%E9%97%B4%EF%BC%8C%E7%9F%AB%E6%83%85%E5%86%99%E5%AE%9E%E6%91%84%E5%BD%B1%EF%BC%8C%E6%B8%85%E5%86%B7%E7%9A%84%E5%85%89%E5%BD%B1%E5%AF%B9%E6%AF%94%EF%BC%8C%E7%BB%86%E8%85%BB%E7%BA%B9%E7%90%86&width=800&height=560&seq=feed-03-x1&orientation=landscape",
  },
  {
    id: 4,
    category: "情感反差",
    tag: "热榜第5",
    title: "白天发糖的CP，深夜互撕的私聊截图被好友曝光",
    summary: "朋友圈里频繁合体的甜蜜搭档，私下对话却一个说一个演。公开恩爱的剧本被扒开后，究竟谁在入戏？",
    author: "观察员·小满",
    date: "昨日 20:18",
    readCount: "11.3万",
    hot: 89,
    image: "https://readdy.ai/api/search-image?query=%E4%B8%A4%E9%83%A8%E6%89%8B%E6%9C%BA%E6%94%BE%E5%9C%A8%E6%B5%85%E7%B2%89%E8%89%B2%E5%BA%8A%E5%8D%95%E4%B8%8A%E4%BA%92%E7%9B%B8%E9%9D%A0%E8%BF%91%EF%BC%8C%E8%BD%AF%E5%92%8C%E7%81%AF%E5%85%89%EF%BC%8C%E7%94%9C%E8%9C%9C%E4%B8%8E%E6%B0%B4%E8%89%B2%E7%9A%84%E5%90%8C%E6%A1%86%E6%84%9F%EF%BC%8C%E9%AB%98%E7%BA%A7%E6%84%9F%E7%94%9F%E6%B4%BB%E6%8B%8D%E6%91%84&width=800&height=560&seq=feed-04-x1&orientation=landscape",
  },
  {
    id: 5,
    category: "网络反差",
    tag: "持续跟进",
    title: "评论区大道理一套套的键盘侠，现实里社恐到不敢点单",
    summary: "网上一口一个别人的生活该怎样过，现实却连和陌生人说话都要做心理建设。反差背后，是藏起来的无力感。",
    author: "观察员·禾子",
    date: "昨日 17:05",
    readCount: "8.1万",
    hot: 84,
    image: "https://readdy.ai/api/search-image?query=%E6%9A%97%E8%89%B2%E9%94%AE%E7%9B%98%E5%92%8C%E5%8F%91%E5%85%89%E5%B1%8F%E5%B9%95%E7%9A%84%E5%91%A8%E5%9B%B4%E7%8E%AF%E5%A2%83%EF%BC%8C%E9%BB%91%E5%A4%9C%E5%8F%AA%E9%9C%B2%E5%87%BA%E9%94%AE%E7%9B%98%E8%83%8C%E5%85%89%E4%BA%AE%E7%82%B9%EF%BC%8C%E5%85%85%E6%BB%A1%E7%A7%91%E6%8A%80%E6%84%9F%E4%B8%8E%E7%A5%9E%E7%A7%98%E6%84%9F%E7%9A%84%E5%86%99%E6%84%8F%E6%91%84%E5%BD%B1&width=800&height=560&seq=feed-05-x1&orientation=landscape",
  },
  {
    id: 6,
    category: "圈子反差",
    tag: "精选",
    title: "cos圈白天的乖巧营业，夜晚群聊的画风突变让人脸红",
    summary: "镜头前甜美营业的成员，私人群里的发言却让老粉直呼不认识。圈内圈外两副面孔，是真实还是人设？",
    author: "观察员·许墨",
    date: "前天 23:11",
    readCount: "13.9万",
    hot: 93,
    image: "https://readdy.ai/api/search-image?query=%E4%BA%8C%E6%AC%A1%E5%85%83%E8%AE%BE%E5%AE%9A%E7%9A%84%E6%BC%82%E4%BA%AE%E5%A5%B3%E7%94%9F%E5%81%B6%E5%83%8F%E8%A7%92%E8%89%B2%E7%85%A7%E7%89%87%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F%E6%91%84%E5%BD%B1%E5%85%A5%E9%97%A8%EF%BC%8C%E9%B2%9C%E8%89%B3%E4%B8%8E%E5%88%86%E6%AD%A3%E9%9D%A2%E5%85%89%E7%85%A7%E4%BA%A4%E6%9B%BF%EF%BC%8C%E5%B9%B4%E8%BD%BB%E6%B4%BB%E5%8A%9B&width=800&height=560&seq=feed-06-x1&orientation=landscape",
  },
  {
    id: 7,
    category: "人设反差",
    tag: "新上榜",
    title: "高冷总裁人设翻车：私下竟给爱猫起名叫小甜甜",
    summary: "对外雷厉风行、人狠话不多的形象，私聊里却满屏卖萌表情包，连宠物备注都甜得发腻。网友：反差才是流量密码。",
    author: "观察员·阿岚",
    date: "前天 16:32",
    readCount: "7.6万",
    hot: 82,
    image: "https://readdy.ai/api/search-image?query=%E5%B7%A5%E4%BD%9C%E5%AE%A4%E9%87%8C%E9%AB%98%E5%86%B7%E9%BB%91%E7%94%B7%E4%B8%8E%E5%8F%B0%E4%B8%8A%E5%8F%AF%E7%88%B1%E7%8C%AB%E5%92%AA%E7%9A%84%E5%AF%B9%E6%AF%94%EF%BC%8C%E6%B8%85%E5%86%B7%E4%B8%8E%E6%9A%96%E5%BF%83%E5%85%B1%E5%AD%98%E7%9A%84%E5%86%99%E6%84%8F%E6%91%84%E5%BD%B1%EF%BC%8C%E5%89%A7%E5%9C%BA%E5%85%89%E6%9A%96%E8%B0%83&width=800&height=560&seq=feed-07-x1&orientation=landscape",
  },
  {
    id: 8,
    category: "校园反差",
    tag: "热议",
    title: "班长与隐藏号主竟是同一人：群管理的两副面孔",
    summary: "明面上严肃管理班群的班长，私下用小号在匿名区吐槽同学，被系统提示音露了馅。场面一度非常尴尬。",
    author: "观察员·栗子",
    date: "3天前 14:20",
    readCount: "6.3万",
    hot: 78,
    image: "https://readdy.ai/api/search-image?query=%E5%AD%A6%E6%A0%A1%E8%B5%B0%E5%BB%8A%E7%9A%84%E6%B8%85%E6%99%A8%E5%85%89%E7%BA%BF%EF%BC%8C%E5%B9%B4%E8%BD%BB%E4%BA%BA%E7%9A%84%E5%8F%8C%E9%9D%A2%E5%BD%B1%E7%9A%84%E6%83%85%E6%84%9F%E6%91%84%E5%BD%B1%EF%BC%8C%E6%B0%91%E6%94%BF%E8%B0%83%EF%BC%8C%E6%9C%89%E5%8A%A8%E6%80%81%E7%9A%84%E6%B0%94%E6%B0%9B&width=800&height=560&seq=feed-08-x1&orientation=landscape",
  },
  {
    id: 9,
    category: "情感反差",
    tag: "持续跟进",
    title: "晒娃好奶爸的深夜，却在和发小倾诉带娃崩溃瞬间",
    summary: "朋友圈里永远温柔耐心的好爸爸，私下聊天却坦诚自己也会在深夜崩溃。反差不是人设崩塌，只是人不止一面。",
    author: "观察员·南乔",
    date: "4天前 21:03",
    readCount: "9.2万",
    hot: 86,
    image: "https://readdy.ai/api/search-image?query=%E7%94%B7%E4%BA%BA%E6%8A%B1%E7%9D%80%E5%AD%A9%E5%AD%90%E7%9A%84%E6%B8%A9%E9%A6%A8%E5%AE%B6%E5%BA%AD%E5%9C%BA%E6%99%AF%EF%BC%8C%E8%BD%AF%E5%92%8C%E6%97%A5%E5%85%89%EF%BC%8C%E6%B0%91%E6%94%BF%E7%94%9F%E6%B4%BB%E5%86%99%E5%AE%9E%E6%91%84%E5%BD%B1%EF%BC%8C%E6%9A%96%E9%A2%9C%E8%89%B2%E8%B0%83%EF%BC%8C%E6%B8%A9%E6%9A%96%E4%BA%B2%E5%AF%86%E6%84%9F&width=800&height=560&seq=feed-09-x1&orientation=landscape",
  },
];

export const categoryTiles: Category[] = [
  {
    name: "人设反差",
    desc: "公开形象与私下言行判若两人的高能案例",
    count: "286 条素材",
    image: "https://readdy.ai/api/search-image?query=%E7%9F%AB%E6%83%85%E9%BB%91%E7%99%BD%E5%AF%B9%E6%AF%94%E7%9A%84%E4%B8%A4%E5%BC%A0%E8%84%B8%E5%AD%94%E5%8D%A1%E7%89%87%E6%8A%A0%E5%9B%BE%E6%84%9F%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%80%A7%E6%91%84%E5%BD%B1%EF%BC%8C%E7%BA%A2%E8%89%B2%E4%B8%8E%E9%BB%91%E8%89%B2%E5%AF%B9%E6%AF%94%EF%BC%8C%E8%BE%B9%E7%BC%98%E8%BD%AF%E5%8C%96&width=600&height=760&seq=cat-01-x1&orientation=portrait",
    accent: true,
  },
  {
    name: "校园反差",
    desc: "书桌前后、宿舍内外的另一面人生",
    count: "194 条素材",
    image: "https://readdy.ai/api/search-image?query=%E9%9D%92%E6%98%A5%E6%A0%A1%E5%9B%AD%E6%9C%9D%E9%98%B3%E4%B8%8B%E7%9A%84%E8%BD%BB%E7%AC%91%E4%B8%8E%E8%AF%BE%E5%A0%82%E7%9A%84%E5%AF%B9%E6%AF%94%EF%BC%8C%E6%B0%91%E6%94%BF%E8%B0%83%E7%94%9F%E6%B4%BB%E6%91%84%E5%BD%B1%EF%BC%8C%E6%98%8E%E4%BA%AE%E6%9A%96%E8%89%B2%E8%B0%83%EF%BC%8C%E6%9C%89%E5%8A%A8%E6%84%9F&width=600&height=760&seq=cat-02-x1&orientation=portrait",
    accent: false,
  },
  {
    name: "职场反差",
    desc: "工位内外、邮件与群聊的两副腔调",
    count: "168 条素材",
    image: "https://readdy.ai/api/search-image?query=%E5%86%B0%E5%86%B7%E7%81%B0%E8%89%B2%E5%8A%9E%E5%85%AC%E6%A1%8C%E5%92%8C%E6%B8%A9%E6%9A%96%E7%81%AF%E5%85%89%E7%9A%84%E5%8A%9E%E5%85%AC%E5%AE%A4%E5%8F%B0%E7%81%AF%E5%AF%B9%E6%AF%94%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%80%A7%E6%91%84%E5%BD%B1%E5%85%A5%E9%97%A8%EF%BC%8C%E6%B8%85%E5%86%B7%E4%B8%8E%E6%9A%96%E5%92%8C%E5%85%B1%E5%AD%98&width=600&height=760&seq=cat-03-x1&orientation=portrait",
    accent: false,
  },
  {
    name: "情感反差",
    desc: "亲密关系里台前与幕后的温差",
    count: "231 条素材",
    image: "https://readdy.ai/api/search-image?query=%E6%B5%85%E7%B2%89%E8%89%B2%E4%B8%8E%E6%9A%96%E7%99%BD%E8%89%B2%E4%BA%A4%E9%94%99%E7%9A%84%E6%B5%AA%E6%BC%AB%E6%83%85%E6%84%9F%E6%91%84%E5%BD%B1%E5%85%A5%E9%97%A8%EF%BC%8C%E8%BD%AF%E5%85%89%E6%89%8B%E5%86%99%E6%84%9F%EF%BC%8C%E9%AB%98%E7%BA%A7%E6%B2%89%E6%B5%B8%E5%BC%8F&width=600&height=760&seq=cat-04-x1&orientation=portrait",
    accent: true,
  },
  {
    name: "网络反差",
    desc: "键盘前后、屏幕内外的人格分裂现场",
    count: "312 条素材",
    image: "https://readdy.ai/api/search-image?query=%E6%9A%97%E8%89%B2%E7%8E%AF%E5%A2%83%E4%B8%8B%E5%8F%91%E5%85%89%E7%9A%84%E5%B1%8F%E5%B9%95%E4%B8%8E%E8%BA%AB%E5%90%8E%E7%9A%84%E9%BB%91%E6%9A%97%E4%BA%BA%E5%BD%B1%EF%BC%8C%E7%A7%91%E6%8A%80%E9%A3%8E%E5%86%99%E6%84%8F%E6%91%84%E5%BD%B1%EF%BC%8C%E9%AB%98%E5%AF%B9%E6%AF%94&width=600&height=760&seq=cat-05-x1&orientation=portrait",
    accent: false,
  },
  {
    name: "圈子反差",
    desc: "兴趣圈层里营业与真实的温差",
    count: "147 条素材",
    image: "https://readdy.ai/api/search-image?query=%E4%BA%8C%E6%AC%A1%E5%85%83%E8%89%B2%E5%BD%A9%E7%B5%AE%E7%BA%B7%E7%9A%84%E5%8A%A8%E6%BC%AB%E9%A3%8E%E8%83%8C%E6%99%AF%E4%B8%8E%E6%B8%85%E5%86%B7%E7%9A%84%E6%97%A5%E5%B8%B8%E5%AF%B9%E6%AF%94%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%80%A7%E5%90%88%E6%88%90%E6%84%9F%EF%BC%8C%E9%B2%9C%E8%89%B3%E5%92%8C%E6%BD%9C&width=600&height=760&seq=cat-06-x1&orientation=portrait",
    accent: false,
  },
];

export const specials: Special[] = [
  {
    key: "a",
    category: "深度专题",
    title: "为什么现在人人都在谈「反差」？一场关于真实与表演的讨论",
    summary:
      "当公开人设与私下言行出现明显温差，「反差」就从网络热词变成了大众情绪出口。我们尝试从分享欲、关注度与「真实感」三个切口，聊聊这股浪潮为何越卷越热。",
    points: [
      "「反差」满足的是一种窥见真实的快感",
      "人设越完美，塌得越快的底层逻辑",
      "从围观到自省：我们都在不同程度地表演",
    ],
    date: "专题更新 · 2026-08-30",
    reads: "28.4万阅读",
    image: "https://readdy.ai/api/search-image?query=%E7%BA%A2%E8%89%B2%E4%B8%8E%E9%BB%91%E8%89%B2%E7%BC%96%E8%BE%91%E9%A3%8E%E6%8A%BD%E8%B1%A1%E8%83%8C%E6%99%AF%E9%85%8D%E5%8A%A8%E6%84%9F%E7%BA%BF%E6%9D%A1%EF%BC%8C%E6%9D%82%E5%BF%97%E5%B0%81%E9%9D%A2%E6%84%9F%E7%9A%84%E8%89%BA%E6%9C%AF%E5%86%99%E6%84%8F%E6%91%84%E5%BD%B1%EF%BC%8C%E9%AB%98%E5%AF%B9%E6%AF%94%E5%AF%93%E8%A8%80%E6%80%A7&width=1200&height=760&seq=spec-01-x1&orientation=landscape",
    featured: true,
  },
  {
    key: "b",
    category: "案例拆解",
    title: "从聊天记录到全民围观：一条「反差线索」是怎么发酵的",
    summary:
      "从一个平台的小小截图，到刷屏各大群聊，再被整理成完整的时间线。我们用真实路径拆解反差线索从出现到爆火的完整链条，帮你看懂信息如何层层放大。",
    points: [
      "首发场景与传播节点的关键作用",
      "截图如何被二次加工与「补全前因后果」",
      "围观心理：先站队，再追问真假",
    ],
    date: "专题更新 · 2026-08-22",
    reads: "19.7万阅读",
    image: "https://readdy.ai/api/search-image?query=%E8%AE%BA%E5%9D%9B%E8%AE%A8%E8%AE%BA%E5%8C%BA%E4%B8%8E%E6%9C%8B%E5%8F%8B%E5%9C%88%E8%BD%AC%E5%8F%91%E7%9A%84%E6%91%84%E5%BD%B1%E5%8C%96%E5%AE%A4%E5%86%85%E6%83%85%E6%99%AF%EF%BC%8C%E6%B8%A9%E6%9A%96%E6%97%A5%E5%85%89%EF%BC%8C%E6%B0%91%E6%94%BF%E8%B0%83%E7%BC%96%E8%BE%91%E9%A3%8E%EF%BC%8C%E7%B9%81%E8%80%8C%E4%B8%8D%E4%B9%B1&width=1200&height=760&seq=spec-02-x1&orientation=landscape",
    featured: false,
  },
];

export const voices: Voice[] = [
  {
    name: "@只吃一面",
    role: "通勤路上的观察者",
    text: "工作日晚饭后的固定节目就是来刷反差雷达，时间线整理得很清楚，省得我在各个群翻来翻去，前因后果一下就明白了。",
  },
  {
    name: "@Cora想睡",
    role: "编辑部同行",
    text: "选材和分类都挺讲究，没有无脑搬运。尤其喜欢那几篇现象拆解，讲得比我顺手写的深度稿还细，读完会有种「原来如此」的感觉。",
  },
  {
    name: "@老白复盘机",
    role: "内容创作者",
    text: "经常来这边找选题灵感和传播路径参考。图片素材整理得规整，引用前也会自己先核对一遍，这一点让我比较放心。",
  },
  {
    name: "@晚风慢半拍",
    role: "夜猫子读者",
    text: "更新是真的快，热点出来没多久就能看到完整梳理。评论区也理性，大家更多在讨论现象本身，氛围舒服。",
  },
];

export const faqs: Faq[] = [
  {
    q: "什么是反差爆料？",
    a: "反差爆料通常指某人在公开场合塑造的形象，与私下言行之间存在明显反差，进而被网友关注并持续讨论的网络现象。它既可以是人设翻车的瓜，也可以是「原来TA私下是这样」的有趣发现，属于当下较热门的话题类型之一。",
  },
  {
    q: "反差雷达的内容更新频率如何？",
    a: "反差雷达每日滚动更新热门现象盘点与话题线索；对于讨论度较高的重点事件，会整理成独立专题，并持续补充时间线、对话细节与相关背景，方便你回看完整的来龙去脉。",
  },
  {
    q: "为什么有的内容会标注「持续跟进」？",
    a: "网络话题常常反转再反转，早期判断未必是最终结论。凡是标注「持续跟进」的内容，说明信息仍在发酵、有待证实，我们会随着新进展补充和修正，也建议你先观望再下结论。",
  },
  {
    q: "可以投稿或提供线索吗？",
    a: "可以。欢迎通过页尾的联系表单提交你认为值得关注的线索或选题。为保证信息的真实性，提交时请尽量附上可核对的出处，我们会先做基础核验，再决定是否整理发布。",
  },
  {
    q: "平台如何处理隐私与版权问题？",
    a: "反差雷达坚持客观、克制的编辑原则：不鼓励无底线扒取个人隐私，不使用未经授权的完整商业内容，涉及真实个人的敏感素材会做必要的匿名化与脱敏处理。我们更关注现象本身，而非具体到个人的猎奇消费。",
  },
];

export const hotTitles = [
  { id: 1, text: "高冷总裁私下竟给爱猫起名「小甜甜」", views: "12.6万", delta: "+320%" },
  { id: 2, text: "学霸课堂笔记工整，聊天却在深夜自嘲摆烂", views: "9.8万", delta: "+180%" },
  { id: 3, text: "白天发糖的情侣，深夜私聊截图却一个说一个演", views: "8.7万", delta: "+95%" },
  { id: 4, text: "评论区满口道理的键盘侠，现实社恐到不敢点单", views: "8.1万", delta: "+76%" },
  { id: 5, text: "cos圈白天的甜美营业，深夜群聊画风突变", views: "7.4万", delta: "+61%" },
  { id: 6, text: "上班邮件礼貌克制，下班群里竟口无遮拦", views: "6.6万", delta: "+43%" },
];

export const stats = [
  { num: "1,200+", label: "累计收录素材" },
  { num: "38", label: "深度现象专题" },
  { num: "12", label: "观察栏目" },
  { num: "24h", label: "全时更新追踪" },
];